export const getSafeSsoContinuation = (value: string | null | undefined) => {
  if (!value?.startsWith('/')) {
    return '/dashboard';
  }

  try {
    const continuation = new URL(value, window.location.origin);

    if (continuation.origin !== window.location.origin || continuation.pathname === '/sso/login') {
      return '/dashboard';
    }

    return `${continuation.pathname}${continuation.search}${continuation.hash}`;
  } catch {
    return '/dashboard';
  }
};
